var _path, _path2, _rect, _path3, _rect2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFig = function SvgFig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fig_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M21.75 26.25A2.25 2.25 0 0 1 24 24h2.25v4.5H24a2.25 2.25 0 0 1-2.25-2.25M27.75 24H30a2.25 2.25 0 0 1 0 4.5h-2.25zM21.75 31.5A2.25 2.25 0 0 1 24 29.25h2.25v4.5H24a2.25 2.25 0 0 1-2.25-2.25"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 27.75,
    y: 29.25,
    fill: "#C0BEBE",
    rx: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M21.75 36.75A2.25 2.25 0 0 1 24 34.5h2.25v2.25a2.25 2.25 0 0 1-4.5 0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#424445",
    rx: 4.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.34 18v-6h4.22v1.313h-2.59v1.03h2.332v1.313H10.97V18zm6.448-6v6h-1.63v-6zm4.668 1.98a.8.8 0 0 0-.12-.272.839.839 0 0 0-.486-.328 1.3 1.3 0 0 0-.349-.044 1.2 1.2 0 0 0-.7.196q-.287.197-.44.566-.15.37-.149.89 0 .528.144.903.143.375.427.574.285.2.706.2.372 0 .619-.11a.8.8 0 0 0 .372-.307.87.87 0 0 0 .123-.469l.28.03h-1.37v-1.16h2.66v.832q0 .82-.349 1.403-.346.58-.955.89-.606.308-1.391.308-.876 0-1.538-.372a2.6 2.6 0 0 1-1.035-1.06q-.369-.69-.369-1.638 0-.744.226-1.319.228-.574.633-.97.404-.397.934-.6a3.1 3.1 0 0 1 1.137-.205q.533 0 .99.152.46.15.812.428.354.275.571.653t.264.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fig_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgFig;